import { render, staticRenderFns } from "./AllBills.vue?vue&type=template&id=70c21dfd&"
import script from "./AllBills.vue?vue&type=script&lang=js&"
export * from "./AllBills.vue?vue&type=script&lang=js&"
import style0 from "./AllBills.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports